// extracted by mini-css-extract-plugin
module.exports = {"root":"coming-soon_root__50VUn","bg":"coming-soon_bg__PitPI","text":"coming-soon_text__SO7s7"};